export default __webpack_public_path__ + "static/media/regulatory--stop--g6.de739f11.png";